const light = Object.freeze({
    primary: '#e17319',
    secondary: '#871e7d',
    navBackground: '#FFFFFF',
    tileBackground: '#FFFFFF',
    appBackground: '#F5F5F5',
    inputBackground: '#FFFFFF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
})

const dark = Object.freeze({
    primary: '#e17319',
    secondary: '#871e7d',
    navBackground: '#2C2C2C',
    tileBackground: '#2C2C2C',
    appBackground: '#1B1B1B',
    inputBackground: '#222222',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
})

const props = Object.freeze({
    headerLogoWidth: 150,
    headerLogoSrc: require('@/assets/custom/images/headers/living-header.jpg')
})

module.exports = Object.freeze({
    light,
    dark,
    props
})

